import React, {useContext, useEffect, useState} from "react";
import { connect } from "react-redux";
import { Context } from "context";
import { zaktualizujRozwiazanie as zaktualizujRozwiazanieAction } from "actions/gameActions";

import { useDrag } from "react-dnd";

import update from "immutability-helper";

import { useDrop } from "react-dnd";


import z10c from "assets/s2/z10/aster_cien.svg";
import z11c from "assets/s2/z10/jezowka_cien.svg";
import z12c from "assets/s2/z10/lawenda_cien.svg";
import z13c from "assets/s2/z10/mak_cien.svg";
import z14c from "assets/s2/z10/wrzos_cien.svg";

export const Box = ({ id, left, top, position, children }) => {
  const [{ isDragging }, drag] = useDrag({
    item: { id, left, top, type: "ItemTypes.BOX" },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  if (isDragging) {
    return <div ref={drag} />;
  }

  return (
    <div className="kwiatuszki" ref={drag} style={{ left, top, position }}>
      {children}
    </div>
  );
};

const Z10 = ({ elementy, zaktualizujElementy,  zaktualizujRozwiazanie }) => {


  
  const {
    canGo, setCanGo
  } = useContext(Context);

  
  const [pos, setPos] = useState()

 

  useEffect(() => {
    setCanGo(false)
  }, [])


  useEffect(() => {
    // const first = elementy[0]
    let count = 0;
    elementy.map( (first, index) => {
    const x1 = first.left + 0.5 * first.width
    const y1 = first.top + 0.5 * first.height
  
    const x2 = first.posLeft + 0.5 * first.width
    const y2 = first.posTop + 0.5 * first.height
  
    if (Math.sqrt(Math.pow(y2-y1, 2) + Math.pow(x2-x1, 2)) < 50){
      count += 1;
      setPos(count) 
      first.left = first.posLeft
      first.top = first.posTop
    }else {
      setPos(count)
    }
  
  
    // console.log(y2-y1)
    // console.log(x2-x1)
  // console.log(Math.sqrt(Math.pow(y2-y1, 2) + Math.pow(x2-x1, 2)))
  })
  
  if(pos === 5) {
    setCanGo(true)
  }else {
    setCanGo(false)
  }
  
  }, [elementy, pos, setCanGo])

  const [collectedProps, drop] = useDrop({
    accept: "ItemTypes.BOX",
    drop(item, monitor) {
      const start_pos = monitor.getInitialSourceClientOffset();
      const delta = monitor.getDifferenceFromInitialOffset();
      // console.log(start_pos, delta);
      const left = item.left
        ? Math.round(item.left + delta.x)
        : start_pos.x + delta.x - 200;
      const top = item.top
        ? Math.round(item.top + delta.y)
        : start_pos.y + delta.y - 250;

      moveBox(item.id, left, top);
      return undefined;
    },
  });
  const moveBox = (id, left, top) => {
    var el = update(elementy, {
      [id]: {
        $merge: { left, top, position: "absolute" },
      },
    });
 

    zaktualizujRozwiazanie(el, 10);
    
  };

  return (
    <div className="z z10" ref={drop}>
      <div className="drop1 drop">
        <img src={z10c} alt="" />
      </div>
      <div className="drop2 drop">
        <img src={z11c} alt="" />
      </div>
      <div className="drop3 drop">
        <img src={z12c} alt="" />
      </div>
      <div className="drop4 drop">
        <img src={z13c} alt="" />
      </div>
      <div className="drop5 drop">
        <img src={z14c} alt="" />
      </div>



      <div className="kwiatki-cont" >
        {Object.keys(elementy).map((key) => {
          const { left, top, position, image, klasa ,title} = elementy[key];
          // console.log(key);      
          return (          
            <Box  className="kwiatuszki" key={key} id={key} left={left} top={top} position={position}>
              <img  className="kwiatki" src={image} alt=""  />
              <p>{title}</p>
            </Box>
          );
        })}
      </div>

    </div>
  );
};

Z10.propTypes = {};

const mapStateToProps = (state) => {
  // console.log(state.gameReducer);
  return {
    elementy: state.gameReducer.rozwiazane_zadania[9].elementy,
    rozwiazane_zadanie: state.gameReducer.rozwiazane_zadania[9],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zaktualizujRozwiazanie: (elementy, zadanieID) =>
      dispatch(zaktualizujRozwiazanieAction(elementy, zadanieID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Z10);
